// This file mimics styles and mixins from _General.Mixins.scss
export var normalize = {
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
};
//# sourceMappingURL=GeneralStyles.js.map